<template>
    <div class="radio-box" v-if="state">
        <div class="popBox" :style="{width: width, height: height}">
            <el-card class="box-card">
                <div slot="header" class="title clearfix">
                    <span>{{title}}</span>
                </div>
                <div class="popBody" ref="popBody">
                    <div v-for="(v, i) in listData" :key="i" class="item">
                        <li @click="radioCheck(v)" :class="{active: checkedValue === v.value, disabled: v.disabled}">
                            <span class="title">{{v.label}}</span>
                            <span class="right-text">{{v.rightText}}</span>
                            <span class="checked" v-show="v.value === checkedValue"><i class="el-icon-check" /></span>
                        </li>
                    </div>
                </div>
                <div class="popFoot">
                    <el-button size="medium" type="primary" @click="success">确定</el-button>
                    <el-button size="medium" @click="cancel">取消</el-button>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CashRadio",
        model: {
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            listData: Array,
            value: {
                type: [Number, String],
                default: ""
            },
            title: {
                type: String,
                default: "请选择"
            },
            width: String,
            height: String,
        },
        data: () => ({
            checkedValue: null
        }),
        mounted: function () {

        },
        methods: {
            cancel: function () {
                this.$emit("stateChange", false);
            },
            radioCheck: function (itemVal) {
                if(!itemVal.disabled) {
                    // let notArr = [0, 1];
                    // let checkedType = 0;
                    // if(this.checkedValue[0] && this.checkedValue[0] !== -1) {
                    //     checkedType = this.listData[this.checkedValue[0]].discount_type;
                    // }
                    // this.$root.log("checkedType", checkedType);
                    //
                    // if(notArr.includes(itemVal.discount_type) || notArr.includes(checkedType) || !this.checkedValue ) {
                    //     this.checkedValue = [];
                    // }
                    // this.checkedValue.push(itemVal.value);
                    // this.$root.log(this.checkedValue);
                    this.checkedValue = itemVal.value;
                }
            },
            success: function () {
                this.$emit("checked", this.checkedValue);
                this.cancel();
            }
        },
        watch: {
            state: function (t) {
                if(t) {
                    this.checkedValue = typeof this.value === "string" ? Number(this.value) : this.value;
                }
            },
        }
    }
</script>

<style scoped>
    .radio-box{
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        left: 0;
        top: 0;
        z-index: 99;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
    }
    .popBox{
        width: 580px;
        height: 440px;
    }
    .title{
        text-align: left;
        font-size: 18px;
    }
    .popBody{
        padding-top: 8px;
        height: 290px;
        overflow-y: auto;
    }
    .item li{
        height: 38px;
        border: 1px solid #e5e5e5;
        margin: 0px 16px 18px;
        padding: 0px 16px;
        cursor: pointer;
        display: flex;
        flex-flow: row nowrap;
    }
    .item li.active{
        border-color: #6cb1e1;
    }
    .item li>.title{
        flex: 1;
        font-size: 14px;
        text-align: left;
    }
    .item li>.right-text{
        flex: 1;
        text-align: right;
        font-size: 12px;
        color: #999999;
    }
    .item li>.checked{
        color: #6cb1e1;
        padding-left: 10px;
    }
    .item li.disabled{
        background-color: #f7f7f7;
    }
    /*.item li.disabled>.checked{*/
        /*color: #b6b6b6;*/
    /*}*/
    .popFoot{
        text-align: right;
        padding-right: 16px;
    }
</style>
